import {
  createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/styles/global.css'
import '@/assets/font/fonts.css' // fonts css
const app = createApp(App);

import BaiduMap from 'vue-baidu-map-3x'

app.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'cbLlqUyQDXLYm9nnfCETPX2GPJxMWBQl',
  // v:'2.0',  // 默认使用3.0
  // type: 'WebGL' // ||API 默认API  (使用此模式 BMap=BMapGL)
});

//全局引入组件
import DataVVue3 from '@kjgl77/datav-vue3'
app.use(DataVVue3)

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
import ElementUI from 'element-plus'
import 'element-plus/dist/index.css'
import locale from 'element-plus/es/locale/lang/zh-cn';
app.use(ElementUI, {
  locale,
});
// 全局注册组件
// 头部导航栏
import navbar from './components/navbar.vue';
app.component('nav-bar', navbar);
// 底部导航栏
import bottombar from './components/bottombar.vue'
app.component('bottom-bar', bottombar);

app.use(store);
app.use(router);
// 挂载根实例
app.mount('#app');